import script from "./DashboardPurchaseHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardPurchaseHistory.vue?vue&type=script&setup=true&lang=js"

import "./DashboardPurchaseHistory.vue?vue&type=style&index=0&id=d5245fde&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5245fde"]])

export default __exports__